import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { BookingCard } from './bookingCard.component';
import { selectCurrentExperience } from '../../../modules/experience';
import { selectBookingDate, selectBookingPrice, selectBookingSlots } from '../../../modules/booking';

const mapStateToProps = createStructuredSelector({
  experience: selectCurrentExperience,
  date: selectBookingDate,
  timeslots: selectBookingSlots,
  bookingPrice: selectBookingPrice,
});

export const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(BookingCard);
